<template>
  <v-app>
    <v-main class="app-bg-grey">
      <section>
        <v-img
          src="/assets/img/cover.jpg"
          height="620"
          style="position: relative"
        >
          <v-container
            class="white--text text-center"
            style="
              margin: 0;
              position: absolute;
              top: 35%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <h1 style="font-weight: 500; font-size: 54pt">Машин сонгох</h1>
            <h4 style="font-size: 18pt">
              Сэлбэг хайх, тоноглол хайх, багаж хайх
            </h4>
            <v-row class="mx-auto mt-8">
              <v-col lg="3" md="auto" cols="12">
                <v-select
                  :items="items"
                  label="Үйлдвэрлэгч"
                  outlined
                  background-color="white"
                ></v-select>
              </v-col>
              <v-col lg="3" md="auto" cols="12">
                <v-select
                  :items="items"
                  label="Загвар"
                  outlined
                  background-color="white"
                ></v-select>
              </v-col>
              <v-col lg="3" md="auto" cols="12">
                <v-select
                  :items="items"
                  label="Модел"
                  outlined
                  background-color="white"
                ></v-select>
              </v-col>
              <v-col lg="3" md="auto" cols="12" class="d-flex flex-row">
                <v-select
                  :items="items"
                  label="Oн"
                  outlined
                  background-color="white"
                ></v-select>
                <v-btn x-large height="56" color="#A8101F" dark class="ml-3"
                  >Хайх</v-btn
                >
              </v-col>
              <!-- <v-col class="d-flex align-start" lg="auto" md="auto" cols="12">
                
              </v-col> -->
            </v-row>
          </v-container>
          <v-container
            class="white--text text-center pb-0"
            style="
              margin: 0;
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <span
              style="
                border-right: 1px solid white;
                font-size: 18px;
                line-height: 21px;
              "
              class="pr-5"
              >Нийт сэлбэг: 321,000</span
            >
            <span class="pl-5"           style="
                font-size: 18px;
                line-height: 21px;
              ">Нийт загвар: 1298</span>
          </v-container>
        </v-img>
      </section>
      <section>
        <v-container class="mt-8">
          <v-row>
            <v-col v-for="(st, index) in selbegtypes" :key="index">
              <banner-card
                flat
                tile
                v-bind:title="st.name"
                style="justify-content: center; align-items: center"
                v-bind:imagesrc="st.images[0].fileUrl"
                v-bind:xpath="st.ref.path"
              >
              </banner-card>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <section>
        <v-container>
          <v-slide-group show-arrows>
            <v-slide-item
              v-for="(image, index) in carousel"
              :key="index"
              style="position: relative"
              class="mx-6"
            >
              <v-img :src="'/assets/img/car' + (index + 1) + '.png'">
                <v-container
                  style="
                    margin: 0;
                    position: absolute;
                    top: 80%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                  "
                  class="white--text"
                  :class="image.class"
                >
                  <h1 class="font-weight-bold">{{ image.title }}</h1>
                  <h2 style="font-size: 18px">
                    {{ image.subtitle }}
                  </h2>
                </v-container>
              </v-img>
            </v-slide-item>
          </v-slide-group>
        </v-container>
      </section>
      <section>
        <v-container>
          <h1
            class="app-title-color"
            style="color: #111; font-size: 1.6em; font-weight: 500"
          >
            Xувийн дэлгүүрүүд
          </h1>
          <v-row no-gutters class="py-6">
            <text-card
              v-for="(store, sindex) in pinnedStores"
              :key="sindex"
              :title="store.name"
              :imagePath="store.images[0].fileUrl"
            >
            </text-card>
          </v-row>
          <div class="text-center mb-6">
            <v-btn
              style="text-transform: none; background-color: transparent"
              outlined
              >Цааш үзэх
              <v-icon>mdi-chevron-down </v-icon>
            </v-btn>
          </div>
        </v-container>
      </section>
    </v-main>
  </v-app>
</template>

<style >
@media (min-width: 1264px) and (max-width: 1903px) {
  .flex.lg5-custom {
    width: 20%;
    max-width: 20%;
    flex-basis: 20%;
  }
}
</style>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");
import firebase from "firebase";
// import YCard from './YCard';
// import CCard from './CategoryCard';
import BannerCard from "./BannerCard";
// import ImageCard from "./ImageCard";
import TextCard from "./TextCard";
import IconTextCard from "./IconTextCard";
export default {
  name: "Home",

  data: () => ({
    mess: "ddd",
    items:[],
    selbegtypes: [],
    pinnedStores: [],
    carousel: [
      {
        title: "SHIELD AD",
        subtitle: "Бүтэн биеийн хуулга, хэсэгчилсэн хуудга",
        class: "text-start",
      },
      {
        title: "VVIP УГААЛГА",
        subtitle: "Америкийн топ брендийн тоног төхөөрөмж",
        class: "text-end",
      },
    ],
  }),
  components: {
    // 'khangal': YCard,
    // CCard,
    BannerCard,
    // ImageCard,
    TextCard,
    IconTextCard,
  },
  created() {
    fb.db
      .collection("selbegtypes")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          let st = doc.data();
          st.id = doc.id;
          st.ref = doc.ref;
          this.selbegtypes.push(st);
        });
      });

    fb.db
      .collection("stores")
      .where("pin", "==", true)
      .orderBy("lastShowDate")
      .limit(6)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(async (doc) => {
          let store = doc.data();
          store.ref = doc.ref;
          store.id = doc.id;
          this.pinnedStores.push(store);
        });
      });
  },
};
</script>
